// Copia SOLO de las 3 claves relevantes para las alertas en vivo (2026-09-10)
// de PASOS_POR_ITEM en packages/web/src/api/lib/calidad-hc-sweep.ts —
// "consentimiento-informado" no participa acá, ese flujo es aparte
// (ConsentimientosTab). Mismo criterio de duplicar constantes pequeñas
// entre paquetes que ya usa SISTEMA_SUBTIPO_CONSENTIMIENTO/CHECKLIST_COMITE
// (packages/hce-chart no comparte build con packages/web). Si se edita un
// texto acá, editar también el original — no hay mecanismo automático de
// sincronización, es una duplicación deliberada y chica.
import type { ClaveHallazgoCompletitud } from '../paciente/chequeoCompletitudConsulta';

export const TITULO_POR_ITEM: Record<ClaveHallazgoCompletitud, string> = {
  'anamnesis-ingreso': 'Anamnesis y examen físico de ingreso',
  'notas-evolucion': 'Notas de evolución (Formulario 005)',
  'epicrisis-alta': 'Epicrisis / resumen de alta (Formulario 006)',
};

export const PASOS_POR_ITEM: Record<ClaveHallazgoCompletitud, string[]> = {
  'anamnesis-ingreso': [
    'Abra la ficha del paciente, sección de formularios (Anexo 1 MSP).',
    'Complete y guarde el Formulario de Anamnesis y Examen Físico que corresponda (002 en Consulta Externa, 003 en Hospitalización) — es el que falta contar como hecho.',
  ],
  'notas-evolucion': [
    'Antes de cerrar esta consulta, abra el Formulario 005 (Evolución y Prescripciones) desde la ficha del paciente.',
    'Registre la nota de evolución de esta consulta — sin esto, la atención queda sin respaldo en la historia clínica.',
  ],
  'epicrisis-alta': [
    'Al dar de alta a un paciente que estuvo internado, abra el Formulario 006 (Epicrisis) desde su ficha.',
    'Complete el resumen de alta antes de cerrar el caso — es obligatorio para todo egreso de internación.',
  ],
};
